import(/* webpackMode: "eager" */ "/vercel/path0/app/kontakt/page.tsx");
